import React from 'react';
import { LinkIcon, ShieldCheckIcon, BookOpenIcon, UsersIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const focusAreas = [{
  title: 'Reconnect',
  description: 'To reconnect and re-establish the people back to God through prayers.',
  icon: LinkIcon
}, {
  title: 'Deliverance',
  description: 'To minister deliverance by preaching life-changing truth to lost, shattered and desperate souls.',
  icon: ShieldCheckIcon
}, {
  title: 'Truth',
  description: "Teaching the uncompromising bible truth that will change your life and bring you to a place of God's wonderful plan.",
  icon: BookOpenIcon
}, {
  title: 'Discipleship',
  description: 'Raise leaders through discipleship and practical leadership training.',
  icon: UsersIcon
}];
export function MinistryFocusSection() {
  return <section id="ministry" className="py-24 md:py-32 bg-charcoal relative overflow-hidden" data-id="element-231">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(circle_at_center,rgba(255,255,255,1)_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-232" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-233">
        <FadeIn className="text-center mb-16 md:mb-24" data-id="element-234">
          <span className="text-gold font-semibold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-235">
            Our Purpose
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-white" data-id="element-236">
            Mission & Vision
          </h2>
          <p className="text-gray-400 font-inter text-lg mt-6 max-w-2xl mx-auto" data-id="element-237">
            Apostle Phillips Ministries is a Christian organization that is
            geared to revive, and restore the love of God in the heart of men.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-238">
          {focusAreas.map((area, index) => {
          const Icon = area.icon;
          return <FadeIn key={area.title} delay={index * 0.15} data-id="element-239">
                <div className="group p-8 md:p-12 bg-dark/50 border border-white/5 hover:border-gold/50 transition-all duration-500 rounded-sm h-full" data-id="element-240">
                  <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-500" data-id="element-241">
                    <Icon className="w-8 h-8 text-gold" data-id="element-242" />
                  </div>
                  <h3 className="text-2xl font-playfair font-bold text-white mb-4" data-id="element-243">
                    {area.title}
                  </h3>
                  <p className="text-gray-400 font-inter leading-relaxed" data-id="element-244">
                    {area.description}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}